var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useContext, useEffect, useCallback, useMemo } from "react";
import Highlight from "react-highlight";
import { Link } from "react-router-dom";
import PublicTemplate from "../../../../components/templates/PublicTemplate";
import Loader from "../../../../components/Loader";
import { BreadcrumbContext } from "../../../../components/Breadcrumb";
import { AuthContext } from "../../../../components/FirebaseAuth";
import { FirebaseAuth } from "../../../../components/FirebaseAuth/firebase";
import Alert from "../../../../components/Alert";
import { useLogsFetcher } from "./useLogsFetcher";
import LogToolbar from "./LogToolbar";
import LogTimeline from "./LogTimeline";
import LogTable from "./LogTable";
import LogScrollSentinel from "./LogScrollSentinel";
import { TIME_RANGE_PRESETS } from "./types";
var DEFAULT_PRESET = "1h";
var Logs = function () {
    var title = "Logs";
    var userData = useContext(AuthContext).userData;
    var setBreadcrumb = useContext(BreadcrumbContext).setBreadcrumb;
    var _a = useState(null), settingsComplete = _a[0], setSettingsComplete = _a[1];
    var _b = useState(true), initialLoading = _b[0], setInitialLoading = _b[1];
    var _c = useState(null), errorMessage = _c[0], setErrorMessage = _c[1];
    // Filters (client-side)
    var _d = useState(""), searchText = _d[0], setSearchText = _d[1];
    var _e = useState([]), severityFilters = _e[0], setSeverityFilters = _e[1];
    // Time range
    var _f = useState(DEFAULT_PRESET), timeRangePreset = _f[0], setTimeRangePreset = _f[1];
    var _g = useState(null), customRange = _g[0], setCustomRange = _g[1];
    // Timezone
    var _h = useState(false), useUtc = _h[0], setUseUtc = _h[1];
    var _j = useLogsFetcher({ accountId: userData.currentAccount.id }), logs = _j.logs, loading = _j.loading, loadingMore = _j.loadingMore, error = _j.error, hasMore = _j.hasMore, oldestFetchedTimestamp = _j.oldestFetchedTimestamp, legacyText = _j.legacyText, fetchLogs = _j.fetchLogs, fetchMore = _j.fetchMore, reset = _j.reset;
    // Compute the effective from/to based on preset or custom range
    var getTimeRange = useCallback(function () {
        if (customRange) {
            return customRange;
        }
        var preset = TIME_RANGE_PRESETS.find(function (p) { return p.value === timeRangePreset; });
        var now = Date.now();
        var duration = preset ? preset.duration : 60 * 60 * 1000;
        return [now - duration, now];
    }, [customRange, timeRangePreset]);
    // Check if subdomain is set up, then fetch logs
    var initializeLogs = useCallback(function (accountId) { return __awaiter(void 0, void 0, void 0, function () {
        var doc, api_settings, _a, from_1, to_1, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSettingsComplete(false);
                    setInitialLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 8, 9, 10]);
                    return [4 /*yield*/, FirebaseAuth.firestore()
                            .collection("subdomains")
                            .doc(accountId)
                            .get()];
                case 2:
                    doc = _b.sent();
                    if (!doc.exists) return [3 /*break*/, 6];
                    api_settings = doc.data();
                    if (!(api_settings !== undefined && api_settings.hasOwnProperty("subdomainName"))) return [3 /*break*/, 4];
                    setSettingsComplete(true);
                    _a = getTimeRange(), from_1 = _a[0], to_1 = _a[1];
                    return [4 /*yield*/, fetchLogs(from_1, to_1)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setSettingsComplete(false);
                    _b.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    setSettingsComplete(false);
                    _b.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8:
                    err_1 = _b.sent();
                    setErrorMessage(err_1.message || "Something went wrong");
                    return [3 /*break*/, 10];
                case 9:
                    setInitialLoading(false);
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [fetchLogs, getTimeRange]);
    // Initial load
    useEffect(function () {
        initializeLogs(userData.currentAccount.id);
        setBreadcrumb([
            { to: "/", text: "Home", active: false },
            {
                to: "/account/" + userData.currentAccount.id + "/",
                text: userData.currentAccount.name + " (".concat(userData.currentAccount.id, ")"),
                active: false,
            },
            { to: null, text: title, active: true },
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData.currentAccount.id]);
    // Sync API-level errors
    useEffect(function () {
        if (error)
            setErrorMessage(error);
    }, [error]);
    // Handle time range preset change
    var handlePresetChange = useCallback(function (preset) {
        setCustomRange(null);
        setTimeRangePreset(preset);
        var presetObj = TIME_RANGE_PRESETS.find(function (p) { return p.value === preset; });
        if (presetObj) {
            var now = Date.now();
            fetchLogs(now - presetObj.duration, now);
        }
    }, [fetchLogs]);
    // Handle custom range change
    var handleCustomRangeChange = useCallback(function (range) {
        setCustomRange(range);
        setTimeRangePreset("");
        fetchLogs(range[0], range[1]);
    }, [fetchLogs]);
    // Handle timeline slider commit – narrows the visible range without refetching,
    // UNLESS the right handle moved while there are still unfetched logs (hasMore).
    var handleTimelineRangeCommit = useCallback(function (range) {
        var _a = getTimeRange(), currentTo = _a[1];
        var rightHandleMoved = range[1] !== currentTo;
        setCustomRange(range);
        setTimeRangePreset("");
        // If the end-time slider moved and there are more logs on the server,
        // re-fetch starting from the new time window so we can populate the gap.
        if (rightHandleMoved && hasMore) {
            fetchLogs(range[0], range[1]);
        }
    }, [getTimeRange, hasMore, fetchLogs]);
    // Handle refresh
    var handleRefresh = useCallback(function () {
        var _a = getTimeRange(), from = _a[0], to = _a[1];
        // If using a preset, recalculate "now"
        if (!customRange) {
            var preset = TIME_RANGE_PRESETS.find(function (p) { return p.value === timeRangePreset; });
            if (preset) {
                var now = Date.now();
                fetchLogs(now - preset.duration, now);
                return;
            }
        }
        fetchLogs(from, to);
    }, [getTimeRange, customRange, timeRangePreset, fetchLogs]);
    // Client-side filtering
    var filteredLogs = useMemo(function () {
        var result = logs;
        // Filter by severity (apply the same error-promotion regex as the table)
        if (severityFilters.length > 0) {
            var errorPattern_1 = /(SERVICE_ERROR|HTTP_ERROR|VALIDATION_ERROR)/;
            result = result.filter(function (entry) {
                var effectiveLevel = errorPattern_1.test(entry.message || "")
                    ? "ERROR"
                    : (entry.level || "").toUpperCase();
                return severityFilters.includes(effectiveLevel);
            });
        }
        // Filter by search text
        if (searchText.trim()) {
            var lower_1 = searchText.trim().toLowerCase();
            result = result.filter(function (entry) {
                return (entry.message || "").toLowerCase().includes(lower_1) ||
                    (entry.level || "").toLowerCase().includes(lower_1) ||
                    (entry.createdAt || "").toLowerCase().includes(lower_1);
            });
        }
        return result;
    }, [logs, severityFilters, searchText]);
    var _k = getTimeRange(), from = _k[0], to = _k[1];
    // Logs further culled by the current time range (for the table)
    var viewFilteredLogs = useMemo(function () {
        return filteredLogs.filter(function (entry) {
            var ts = new Date(entry.createdAt).getTime();
            return ts >= from && ts <= to;
        });
    }, [filteredLogs, from, to]);
    return (_jsx(_Fragment, { children: initialLoading ? (_jsx(PublicTemplate, { children: _jsx(Loader, { size: "5x", text: "Loading..." }) })) : (_jsx(_Fragment, { children: _jsxs("div", { className: "container-fluid", children: [_jsxs("div", { className: "animated fadeIn", children: [errorMessage !== null && (_jsx(Alert, { type: "danger", message: errorMessage, dismissible: true, onDismiss: function () { return setErrorMessage(null); } })), settingsComplete === false && (_jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: "Finish your API setup" }), _jsx("div", { className: "card-body", children: _jsxs("p", { children: ["Before your API can go live, you need to set your API settings. Please edit your \u00A0", _jsx("b", { children: _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/settings", children: "API Settings" }) }), "."] }) })] })), !userData.currentAccount.subscriptionStatus && (_jsx("div", { className: "card", children: _jsx("div", { className: "card-body", children: _jsxs("p", { children: ["Account status is not active,", " ", _jsx(Link, { to: "/account/" + userData.currentAccount.id + "/plan", children: "activate a plan here to continue" }), "."] }) }) })), legacyText !== null && (_jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: title }), _jsx("div", { className: "card-body", children: _jsx(Highlight, { className: "language-accesslog", children: legacyText }) })] })), settingsComplete && legacyText === null && (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 2 }, children: [_jsxs("div", { style: {
                                            position: "sticky",
                                            top: 56, // below the CoreUI fixed header
                                            zIndex: 100,
                                            // Must match the page background so rows scroll out of
                                            // sight behind the sticky header. Read it from the theme
                                            // rather than hardcoding, so it can't drift again.
                                            backgroundColor: "var(--surface-page)",
                                            paddingBottom: 2,
                                        }, children: [_jsx(LogToolbar, { searchText: searchText, onSearchChange: setSearchText, severityFilters: severityFilters, onSeverityChange: setSeverityFilters, timeRangePreset: timeRangePreset, onTimeRangePresetChange: handlePresetChange, customRange: customRange, onCustomRangeChange: handleCustomRangeChange, onRefresh: handleRefresh, loading: loading, useUtc: useUtc, onUseUtcChange: setUseUtc }), _jsx(LogTimeline, { logs: filteredLogs, from: from, to: to, hasMore: hasMore, oldestFetchedTimestamp: oldestFetchedTimestamp, onViewRangeCommit: handleTimelineRangeCommit })] }), _jsx(LogTable, { logs: viewFilteredLogs, loading: loading && logs.length === 0, useUtc: useUtc }), _jsx(LogScrollSentinel, { hasMore: hasMore, loading: loadingMore, onLoadMore: fetchMore })] }))] }), _jsx(Alert, { type: "info", message: "LTI logs are stored for 7 days. Use the time range and filters to narrow your search. These logs should be used for debugging and troubleshooting purposes only. Other logs may be stored on our servers for up to 30 days. If you need access to these logs, please contact us at support@ltiaas.com." })] }) })) }));
};
export default Logs;
